import { SiegADComponentsVue, SIEG_NOTIFY_KEY, type SiegNotifyPayload } from '@sieg-ad/componentes-vue';
//@ts-ignore
import '@sieg-ad/componentes-vue/styles';
import { successToast, errorToast, warnToast, infoToast } from '~/utils/toast';
import { useThemeStore } from '~/stores/theme';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(SiegADComponentsVue);

  // Tema escolhido pelo usuário (persistido no navegador), antes da primeira tela.
  useThemeStore().init();

  // Notificador usado por componentes do pacote (ex.: STable ao ativar/desativar item).
  nuxtApp.vueApp.provide(SIEG_NOTIFY_KEY, ({ type, message }: SiegNotifyPayload) => {
    if (type === 'success') successToast(message);
    else if (type === 'error') errorToast(message);
    else if (type === 'warning') warnToast(message);
    else infoToast(message);
  });
});
